export default "__VITE_ASSET__5f3950f5__"